module.exports = __webpack_public_path__ + "img/Arrow_Close.f45e42d0.svg";